
export enum TextMessageCampaignVerificationStatus {
	PENDING = "PENDING",
	IN_PROGRESS = "IN_PROGRESS",
	FAILED = "FAILED",
	VERIFIED = "VERIFIED"
}